import axios from 'axios';
import Micromodal from 'micromodal';
import { FC, useEffect, useState } from 'react';
import { getModalOption, Setting, Subscription, SubscriptionLine } from '../../App';
import { CUSTOMER_API_URL } from '../../constants';
import { SpinButton } from '../SpinButton';

import base from '../../styles/Base.module.css';
import style from '../../styles/SubscriptionDetail.module.css';

export const ChangeQuantity: FC<{
  subscriptionContactId: string;
  line: SubscriptionLine;
  setting: Setting;
  updateSubscription: () => void;
}> = ({ subscriptionContactId, line, setting, updateSubscription }) => {
  const [subscription, setSubscription] = useState<Subscription>();
  const [quantity, setQuantity] = useState<number>(line.quantity);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [isProc, setIsProc] = useState<boolean>(false);

  useEffect(() => {
    // MicroModal の初期化
    Micromodal.init();

    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscription`,
        {
          subscriptionId: subscriptionContactId,
        },
        { headers: { Authorization: setting.token } },
      )
      .then((response) => {
        setSubscription(response.data);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!subscriptionContactId || !subscription) {
    return <></>;
  }

  const originQuantity = line.quantity;
  const planId = line.sellingPlanId;
  const lineId = line.lineId;

  // 変更ボタンをクリックした際の挙動
  // --------------------------------------------
  const onClickQuantityModify = async () => {
    setIsProc(true);

    console.log({ line });
    // console.log({quantity});

    if (quantity === 0) {
      //   // 0の場合は削除
      try {
        await axios
          .post(
            `${CUSTOMER_API_URL}?action=removeSubscriptionLine`,
            {
              subscriptionId: subscriptionContactId,
              subscriptionLine: line,
            },
            {
              headers: { Authorization: setting.token },
            },
          )
          .then((response) => {
            console.log({ response });
          });
      } catch (e) {
        console.log(e);
        Micromodal.show('modal-error', getModalOption(setting));
        setIsProc(false);
        return;
      }
      window.parent.postMessage({ action: 'completeRemoveQuantity' }, '*');
    } else {
      try {
        await axios
          .post(
            `${CUSTOMER_API_URL}?action=updateSubscriptionLine`,
            {
              subscriptionId: subscriptionContactId,
              // variantId: line.variantId,
              // planId,
              lineId,
              quantity,
            },
            {
              headers: { Authorization: setting.token },
            },
          )
          .then((response) => {
            console.log({ response });
            // console.log({subscription})
            setSubscription({
              ...subscription!,
              subscriptionLines: subscription!.subscriptionLines.map((line) => {
                if (line.lineId !== response.data.lineId) {
                  return line;
                }
                return response.data;
              }),
            });
            updateSubscription();
            setIsChanged(false);
          });
        window.parent.postMessage({ action: 'completeChangeQuantity' }, '*');
      } catch (e) {
        console.log(e);
        Micromodal.show('modal-error');
        setIsProc(false);
        return;
      }
    }

    // setIsProc(false);
  };

  // 数量変更ボタンのクリックした時の挙動
  // --------------------------------------------
  const onChangeQuantity = async (e: any) => {
    console.log({ e });
    await setQuantity(e);
    if (e !== originQuantity) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  };

  return (
    <div className={style.productQuantity}>
      <SpinButton min={0} value={quantity} onChange={onChangeQuantity} />
      <button
        className={`${base.sectionBtn} ${style.productQuantityButton} `}
        disabled={!isChanged}
        onClick={onClickQuantityModify}
      >
        {/* {
          isProc ? <Spinner isLoading /> : '変更'
        } */}
        変更
      </button>
    </div>
  );
};
